import * as React from "react";
import {
  InputElementUnion,
  IFormulaResultElement,
} from "@graffer-inc/form-schema";
import { CommonPropertiesEditor } from "../common-properties-editor";
import { NumberValidationEditor } from "../number-validation-editor";

type FormulaResultEditorProps = {
  element: IFormulaResultElement;
  onElementUpdate: (arg: InputElementUnion) => void;
};

export const FormulaResultEditor: React.FC<FormulaResultEditorProps> = ({
  element,
  onElementUpdate,
}) => {
  return (
    <>
      <CommonPropertiesEditor
        element={element}
        onElementUpdate={onElementUpdate}
      />
      <div className="field">
        <label className="label">数式設定</label>
        <div className="control">
          <p>{element.formulaId}</p>
        </div>
      </div>
      <NumberValidationEditor
        element={element}
        onElementUpdate={onElementUpdate}
      />
    </>
  );
};
